import { UserRow } from './UserRow';

export const UserList = ({ currentUser, onRemove, onRoleChange, users }) => (
  <section>
    <div className="d-flex align-items-center justify-content-between gap-3 mb-3">
      <div>
        <span className="users-eyebrow">Accounts</span>
        <h4 className="m-0">All Users</h4>
      </div>
      <span className="badge bg-dark">{users.length}</span>
    </div>

    {users.length ? (
      <div className="list-group gap-2">
        {users.map((user) => (
          <UserRow
            key={user.id}
            currentUser={currentUser}
            onRemove={onRemove}
            onRoleChange={onRoleChange}
            user={user}
          />
        ))}
      </div>
    ) : (
      <div className="card border-0 p-4 text-center">
        <p className="m-0">No users found.</p>
      </div>
    )}
  </section>
);
